import { gql } from "@apollo/client";

export const SUBMIT_DSP_ADJUST_BILL = gql`
  mutation SubmitDspAdjustBill(
    $billId: ID!
    $fileBase64: String!
    $fileName: String!
  ) {
    submitDspAdjustBill(
      billId: $billId
      fileBase64: $fileBase64
      fileName: $fileName
    )
  }
`;

export interface SubmitDspAdjustBillVariables {
  billId: string;
  fileBase64: string;
  fileName: string;
}

export interface SubmitDspAdjustBillData {
  submitDspAdjustBill: number;
}
